<template>
    <div class="extra">
        <el-row :gutter="10">
            <el-col :span="9">
                <p class="extra-label">Désignation</p>
                <el-input :value="extra.label" placeholder="Nom la prestation" @input="saveLabel"></el-input>
            </el-col>
            <el-col :span="6">
                <p class="extra-label">PUHT (€)</p>
                <el-input :value="extra.unit_price_ht" type="number" @input="savePrice"></el-input>
            </el-col>
            <el-col :span="3">
                <p class="extra-label">Quantité</p>
                <el-input :value="extra.quantity" type="number" @input="saveQuant"></el-input>
            </el-col>
            <el-col :span="6">
                <p class="extra-label">TVA applicable (%)</p>
                <el-input :value="extra.vat" type="number" @input="saveVat"></el-input>
            </el-col>
        </el-row>
        <i class="el-icon-delete delete-icon" @click="removeExtra"></i>
    </div>
</template>

<script>

export default {
    props: {
        extra: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    methods: {
        removeExtra() {
            this.$emit('removeExtra', this.index);
        },
        saveLabel(value) {
            this.$emit('saveInfo', {
                index: this.index,
                key: 'label',
                value: value
            });
        },
        savePrice(value) {
            this.$emit('saveInfo', {
                index: this.index,
                key: 'unit_price_ht',
                value: value
            });
        },
        saveQuant(value) {
            this.$emit('saveInfo', {
                index: this.index,
                key: 'quantity',
                value: value
            });
        },
        saveVat(value) {
            this.$emit('saveInfo', {
                index: this.index,
                key: 'vat',
                value: value
            });
        },
    },
};
</script>

<style lang="scss">
.extra {
    padding: 0 20px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    .delete-icon {
        margin-left: 20px;
        margin-top: 14px; // label font-size (9) + label margin-bottom (5)
        cursor: pointer;
        &:hover {
            color: #409EFF;
        }
    }
    .extra-label {
        font-size: 9px;
        margin-bottom: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Facturation/extraBillingInfo.vue